'use client';

import MuiBox from '@new-components/atoms/MuiBox';
import MuiTypography from '@new-components/atoms/MuiTypography';
import MuiIconButton from '@new-components/atoms/MuiIconButton';

import {QuotesIcon} from '@components/SVGIcon/Icons/Quote';

import PrevSlideIcon from '@components/SVGIcon/Icons/PrevSlideIcon';
import NextSlideIcon from '@components/SVGIcon/Icons/NextSlideIcon';

import {MediaQuery} from '@constants/theme';

import {UserExperiences} from '@new-components/molecules/TestimonialsOnExperiences/types';

const TestimonialsContentSection = ({
  handlePrev,
  handleNext,
  userExperinces,
}: {
  handlePrev: () => void;
  handleNext: () => void;
  userExperinces: UserExperiences;
}): JSX.Element => {
  return (
    <>
      <MuiBox
        sx={{
          paddingX: 11,
          paddingTop: 14,
          width: '50%',
          display: 'flex',
          flexDirection: 'column',
          positon: 'relative',
          [MediaQuery.mobile]: {
            width: '100%',
            padding: 0,
          },
        }}>
        <MuiBox
          sx={{
            [MediaQuery.mobile]: {
              width: '100%',
            },
          }}>
          <MuiBox
            sx={{
              [MediaQuery.mobile]: {
                'marginTop': 3,
                '& svg': {
                  width: '32px !important',
                  height: '25px !important',
                },
              },
              '& svg': {
                width: 47,
                height: 37,
              },
            }}>
            <QuotesIcon />
          </MuiBox>
          <MuiTypography
            sx={{
              fontSize: '19px',
              lineHeight: '125%',
              fontWeight: 300,
              color: '#2D2D2D',
              letterSpacing: '-0.8px',
              marginTop: 4,
              [MediaQuery.mobile]: {
                fontSize: '15px',
                letterSpacing: '-0.4',
                marginTop: 1,
              },
            }}>
            {userExperinces?.testimony}
          </MuiTypography>
          <MuiTypography
            sx={{
              color: '#2D2D2D',
              fontSize: '14px',
              fontWeight: 500,
              lineHeight: '140%',
              marginTop: 2,
              letterSpacing: '-0.8px',
              [MediaQuery.desktop]: {
                fontSize: '17px',
                lineHeight: '140%',
                fontWeight: 500,
                letterSpacing: '-0.8px',
                marginTop: 3,
              },
            }}>
            {`${userExperinces?.name}, ${userExperinces?.age}`}
          </MuiTypography>
        </MuiBox>
        {/* Navigation buttons to be visibe via desktop view */}
        <MuiBox
          sx={{
            display: 'none',
            gap: 2,
            marginTop: 14,
            [MediaQuery.desktop]: {
              display: 'flex',
            },
          }}>
          <MuiIconButton
            onClick={handlePrev}
            data-testid='fcc-prev-button'
            sx={{
              'width': '40px',
              'height': '40px',
              '&.Mui-disabled': {
                opacity: 0.5,
              },
              'cursor': 'pointer',
            }}>
            <PrevSlideIcon />
          </MuiIconButton>
          <MuiIconButton
            onClick={handleNext}
            data-testid='fcc-next-button'
            sx={{
              'width': '40px',
              'height': '40px',
              '&.Mui-disabled': {
                opacity: 0.5,
              },
              'cursor': 'pointer',
            }}>
            <NextSlideIcon />
          </MuiIconButton>
        </MuiBox>
      </MuiBox>
    </>
  );
};

export default TestimonialsContentSection;
